import React, { useState, useRef, useEffect, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { Swiper, ImageViewer, Mask } from 'antd-mobile'
import { ArrowsAltOutline } from 'antd-mobile-icons'
// import { debounce } from 'lodash'
import debounce from 'lodash/debounce';
import { replaceCDNDomain, formatJSON } from '../../utils'
import { addBehaviorsRecord } from '../../utils/BehaviorstatsHelp'
import { getLanguageStore } from '../../utils/storage/language'
import { getMemberInfo } from '../../utils/storage/store'
import { getFromView } from '../../utils/session/store'
import { selectPmList } from '../../store/reducers/hotel';
import { getActivityModel, getCouponRuleModel } from '../../model/store'



import KeepAlivePopup from '../KeepAlivePopup'
import PopupContent from '../PopupContent'
import PromotionDetail from '../PromotionList/Detail'
import CouponModal from '../PromotionList/CouponModal'
import BookingModal from '../PromotionList/BookingModal'

// import { categories, menuItems, bannerList } from '../../data/products';

import './index.less'
import defImg from '../../assets/images/def_img_food.png'
import AutoImage from '../AutoImage'
import { getUrlHashName } from '../../utils/page'
const overHeight = 80;

const Banner = (props) => {
    const { banners = [], showImageCount = true, paddingHeight = 0, from = 'merchant', storeInfo, getActFromRes = true } = props;
    const pmList = useSelector(selectPmList)
    // console.log(banners, 'banners==========', storeInfo)
    const [showVideoModal, setShowVideoModal] = useState(false);
    const [currentVideo, setCurrentVideo] = useState(null);
    const [imgHeight, setImgHeight] = useState(overHeight);
    const [actDetail, setActDetail] = useState(null)
    const [actList, setActList] = useState([])
    const [popupState, setPopupState] = useState({
        couponVisible: false,
        curCoupon: null,
        bookingBoxVisible: false,
        bookingProducts: []
    })

    const videoRefs = useRef([]); // 视频refs
    const bannerRef = useRef(null);
    const swiperRef = useRef(null);
    const { memberId = '' } = getMemberInfo() || {}

    // 计算图片高度
    const calculateImgHeight = () => {
        if (!bannerRef.current) return;
        const width = bannerRef.current?.offsetWidth;
        // 假设我们要保持 16:9 的宽高比
        const height = (width * 9) / 16;
        setImgHeight(height);
    }

    // 处理图片点击
    const handleImageClick = (index, img) => {
        // setCurrentImageIndex(index);
        // setShowImageViewer(true);
        if (img && img.from === 'activity') {
            // console.log(img, 'img==========')
            setActDetail({ ...img.data, placeFlag: 2 })

            //banner图片点击行为统计
            addBehaviorsRecord({
                behaviorType: 160100,
                behavior: 160101,
                storeId: storeInfo.storeId,
                value1: 2,
                value2: img.data.activityId,
                value3: img.data.contentType
            })
        } else {
            ImageViewer.Multi.show({ images: productImageList.map(item => replaceCDNDomain(item.url)), defaultIndex: index })
            addBehaviorsRecord({
                behaviorType: 160200,
                behavior: 160204,
                storeId: storeInfo.storeId,
                value1: `${from}-banner`,
                value2: getUrlHashName(),
            })
        }

    };

    // 处理视频点击
    const handleVideoClick = (videoUrl) => {
        setCurrentVideo(videoUrl);
        setShowVideoModal(true);
    };

    const getActivityList = useCallback(() => {
        getActivityModel({
            relateId: storeInfo.storeId,
            positions: '401,403,407',
            relateType: 801,
            curLanguage: getLanguageStore(),
        }).then(res => {
            console.log(res, 'res==========')

            const fromView = getFromView()
            if (from === 'merchant' && !fromView) {

                let nList = [...res]
                const { storeArea } = storeInfo
                const { roomTypeId } = storeArea || {}
                if (roomTypeId) {
                    nList = nList.filter(item => {
                        const { extendColumn } = item
                        const extendObj = formatJSON(extendColumn)
                        if (extendObj && extendObj.notApplicableRoomTypeIds) {
                            const notApplicableRoomTypeIds = extendObj.notApplicableRoomTypeIds.split(',').map(id => parseInt(id))
                            return !notApplicableRoomTypeIds.includes(roomTypeId)
                        }
                        return true
                    })
                }
                const couponItem = nList.filter(item => item.contentType === 3 && item.param3 === '1')
                const bookingProducts = nList.filter(item => [1, 4, 5, 6].includes(item.contentType) && item.param3 === '1')
                popupCouponContent(couponItem)
                popupBookingBox(bookingProducts)
            }


            setActList(res)
        }).catch(err => {
            console.log(err, 'err==========')
        })
    }, [storeInfo])

    // 获取优惠券规则
    const getCouponRule = useCallback(async (ids) => {
        try {
            const res = await getCouponRuleModel({
                couponRuleIds: ids,
                curLanguage: getLanguageStore,
                memberId
            }, true)
            return res.filter(item => !item.couponState)
        } catch (error) {
            console.error('获取优惠券规则失败:', error)
            return []
        }
    }, [memberId])

    // 显示优惠券弹窗
    const popupCouponContent = useCallback(async (item) => {
        let nObj = {}
        if (Array.isArray(item)) {
            if (item.length === 0) return

            if (item.length === 1) {
                nObj = { ...item[0] }
            } else {
                nObj.list = item
                nObj.param2 = item.map(o => o.param2).join(',')
            }
        }
        if (!nObj?.param2) return

        const couponList = await getCouponRule(nObj.param2)
        if (couponList.length > 0) {
            setTimeout(() => {
                setPopupState(prev => ({ ...prev, couponVisible: true, curCoupon: nObj }))
            }, 1000)
        }
    }, [getCouponRule, popupState])

    // 显示预订弹窗
    const popupBookingBox = useCallback((arr) => {
        if (arr.length > 0) {
            setPopupState(prev => ({ ...prev, bookingBoxVisible: true, bookingProducts: arr }))
        }
    }, [])

    // 处理视频播放状态
    useEffect(() => {
        const handleVisibilityChange = () => {
            videoRefs.current.forEach(video => {
                if (video) {
                    if (document.hidden) {
                        video.pause();
                    } else {
                        video.play().catch(() => {
                            console.log('自动播放失败');
                        });
                    }
                }
            });
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    // 监听窗口大小变化
    useEffect(() => {
        calculateImgHeight(); // 初始计算

        const handleResize = debounce(calculateImgHeight, 100);
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (storeInfo && storeInfo.storeId && from === 'merchant' && getActFromRes) {
            console.log(banners, 'banners==========', storeInfo)
            setTimeout(() => {
                getActivityList()
            }, 1100)
        }
    }, [getActFromRes, storeInfo, from])

    // banners.push({type:'video',url:'https://test-file.jimutour.com/upload/store_images/202509/18/32441172614-1-192.mp4'})

    // banners.push({type:'video',url:'http://test-file.jimutour.com/upload/tour_video/202404/12/20240412100704_404.mp4'})
    // 获取视频和图片
    const productVideo = banners.filter(item => item.type === 'video');
    const productImageList = banners.filter(item => item.type === 'image');

    //position 位置 401 banner
    //contentType 内容类型 1 富文本 3 优惠券 4 预约产品
    const pmArr = getActFromRes ? actList : pmList[from] || []
    let actArr = pmArr.filter(item => item.position === 401 && [1, 2, 3, 4, 5, 6, 7].includes(item.contentType))
    if (from === 'merchant') {
        actArr = actArr.filter(item => item.relateId === storeInfo.storeId && item.relateType === 801)
    } else {
        actArr = actArr.filter(item => item.relateType === 802)
    }
    if (actArr.length > 0) {
        actArr.forEach(item => {
            productImageList.push({ id: pmArr.length + 1, type: 'image', url: item.imageArray[0], from: 'activity', data: item })
        })
    }
    console.log(actArr, 'actArr==========')

    let pHeight = paddingHeight > 0 ? paddingHeight + 10 : 0

    let currentIndex = 0;
    return (
        <div className="banner-container" ref={bannerRef}>
            {(productImageList.length > 0 || productVideo.length > 0) && (
                <Swiper
                    ref={swiperRef}
                    // autoplay
                    loop
                    autoplayInterval={3000}
                    indicatorProps={{
                        color: '#fff'
                    }}
                    onIndexChange={(index) => {
                        currentIndex = index;
                    }}>
                    {
                        productVideo.map((item, index) => (
                            <Swiper.Item autoplay key={index}>
                                <div onClick={() => handleVideoClick(item.url)}>
                                    <video
                                        src={item.url}
                                        width="100%"
                                        height={imgHeight > overHeight ? imgHeight : '100%'}
                                        controls

                                        style={{ /*pointerEvents: 'stroke',//*/ objectFit: 'cover' }} />
                                </div>

                            </Swiper.Item>))
                    }
                    {
                        productImageList.map((img, index) => (
                            <Swiper.Item autoplay key={index}>
                                <div
                                    className={`s-content ${paddingHeight > 0 ? 'p10 inner-img-radius' : ''}`}
                                    style={imgHeight > overHeight ? { height: imgHeight } : null}
                                    onClick={() => handleImageClick(index, img)}>
                                    <AutoImage
                                        src={img.url}
                                        style={{ width: '100%', height: imgHeight > overHeight ? imgHeight - pHeight : null }}
                                        alt=""
                                        onError={e => {
                                            e.target.onerror = null;
                                            e.target.src = defImg;
                                        }} />
                                    {
                                        img.from === 'activity' && (
                                            <div className='bn-content-wrapper'>
                                                <div className='bn-content-title'>{img.data.activityTitle}</div>
                                                <div className='bn-content-desc'>{img.data.briefDescription}</div>
                                            </div>
                                        )
                                    }
                                </div>
                            </Swiper.Item>

                        ))
                    }
                </Swiper>
            )}

            {/* 视频播放弹窗 */}
            {
                showVideoModal ?
                    <Mask visible={showVideoModal}
                        onMaskClick={() => setShowVideoModal(false)}>
                        <div className="video-modal">
                            <video
                                src={currentVideo}
                                controls
                                autoPlay
                                style={{
                                    width: '100%',
                                    maxHeight: '80vh',
                                    objectFit: 'contain'
                                }}
                            />
                        </div>
                    </Mask>
                    : null
            }

            {
                showImageCount && (
                    <div className='img-count' onClick={() => {
                        handleImageClick(currentIndex)
                    }}>
                        <div className='jm-flex'>
                            <div>
                                <ArrowsAltOutline fontSize={20} color='var(--adm-color-primary)' />
                            </div>
                            {/* <div><span className='p-num'>{productImageList.length}</span></div> */}
                        </div>
                    </div>
                )
            }
            {/* 详情弹窗 */}
            {actDetail && (
                <KeepAlivePopup
                    visible={!!actDetail}
                    onClose={() => setActDetail(null)}
                    position='bottom'
                >
                    <PopupContent>
                        <PromotionDetail
                            detail={actDetail}
                            callback={() => setActDetail(null)}
                        />
                    </PopupContent>
                </KeepAlivePopup>
            )}

            {/* 优惠券弹窗 */}
            <CouponModal
                visible={popupState.couponVisible}
                coupon={popupState.curCoupon}
                onClose={() => setPopupState(prev => ({ ...prev, couponVisible: false }))}
                storeId={storeInfo.storeId}
                placeFlag={1}
            />

            {/* 预订弹窗 */}
            <BookingModal
                visible={popupState.bookingBoxVisible}
                products={popupState.bookingProducts}
                onClose={() => setPopupState(prev => ({ ...prev, bookingBoxVisible: false }))}
                onItemClick={(item) => {
                    //预订弹窗点击行为统计
                    addBehaviorsRecord({
                        behaviorType: 160100,
                        behavior: 160101,
                        storeId: storeInfo.storeId,
                        value1: 1,
                        value2: item.activityId,
                        value3: item.contentType
                    })
                    setActDetail({ ...item, placeFlag: 1 })
                }}
            />
        </div>
    )
}

export default Banner
